import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import providers from './providers';
import { enableProdMode } from '@angular/core';
import { initSentry } from './sentry';

initSentry();
if (import.meta.env.NG_APP_PRODUCTION === 'true') {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
  providers,
}).catch(err => console.log(err));
